import { LiveAnnounce } from "../live-announce";
import { VisuallyHidden } from "../visually-hidden";
import type { CalendarDate } from "@internationalized/date";
import { longDateFormat, toDateString } from "./date-input";

export const AnnounceSelectedDate = ({
  selectedDate,
}: {
  selectedDate?: CalendarDate;
}) => {
  const description = selectedDate
    ? `${toDateString(selectedDate, longDateFormat)} selected.`
    : null;
  return <LiveAnnounce as={VisuallyHidden}>{description}</LiveAnnounce>;
};
AnnounceSelectedDate.displayName = "DatePicker.AnnounceSelectedDate";
